/**
 * AdminIncidentRpcClient - AtomRpc integration for admin incident endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminIncidentRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminIncidentRpcClient extends AtomRpc.Tag<AdminIncidentRpcClient>()(
  "AdminIncidentRpcClient",
  {
    group: AdminIncidentRpcs,
    protocol: makeRpcClientLayer(AdminIncidentRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
